import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
	makeStyles,
	Typography
} from '@material-ui/core';

import Fido from "../utils/Fido";
import Constants from "../utils/Constants";
import SentimentBehindNumbers from "../reports/components/SentimentBehindNumbers";
import OverviewReportLayout from "../reports/components/OverviewReportLayout";
import StudentSentimentReportItem from "../reports/components/StudentSentimentReportItem";

const styles = makeStyles(theme => ({
	numbersTitle: {
		paddingBottom: "0px !important"
	}
}));

function NationalStudentSentiment(props) {
	const [sentimentData, setSentimentData] = useState(null);
	const [sentimentFidoError, setSentimentFidoError] = useState(false);
	const [previousDays, setPreviousDays] = useState(30);

	let classes = styles(),
		{updateHeader, resetHeader, location, showSnackbar} = props;


	useEffect(() => {
		updateHeader({title: "national student sentiment", primary: true});
		return () => resetHeader();
	}, [updateHeader, resetHeader]);

	useEffect(() => {
		let fido = new Fido(),
			url = Constants.SERVICES.SENTIMENT.getUrl();

		(async function load() {
			setSentimentData(null);
			let data = await fido.fetch(url, {cors: true, query: {previousDays: previousDays}})
				.catch(error => {
					setSentimentFidoError(true);
					return showSnackbar(error.message);
				});

			if (data) {
				setSentimentData(data.data);
			}
		})();

		return () => fido.dropIt();
	}, [showSnackbar, previousDays]);

	const executeFilter = (filterObj) => {
		if (JSON.stringify(filterObj.previousDays) !== JSON.stringify(previousDays)) {
			setPreviousDays(filterObj.previousDays ? Number(filterObj.previousDays[0]) : 30);
		}
	};

	return (
		<OverviewReportLayout
			showAccounts={false}
			location={location}
			forcePreviousDays
			previousDays={previousDays}
			filterCallback={executeFilter}>
			<StudentSentimentReportItem
				fullWidth
				id="sentimentchart"
				data={sentimentData}
				previousDays={previousDays}
				useMoreInfoDialog={false}
				fidoError={sentimentFidoError} />
			<Typography className={classes.numbersTitle} variant="subtitle1">Behind The Numbers</Typography>
			<SentimentBehindNumbers fullWidth />
		</OverviewReportLayout>
	);
}

NationalStudentSentiment.propTypes = {
	location: PropTypes.object,
	updateHeader: PropTypes.func.isRequired,
	resetHeader: PropTypes.func.isRequired,
	showSnackbar: PropTypes.func.isRequired
};

export default NationalStudentSentiment;